import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BadgeComponent } from '@epicuro-next/ataraxia/badge';
import { ButtonsModule } from '@epicuro-next/ataraxia/buttons';
import { CardModule } from '@epicuro-next/ataraxia/card';
import { CarouselModule } from '@epicuro-next/ataraxia/carousel';
import { ConcatenatedObjectFieldsComponent } from '@epicuro-next/ataraxia/concatenated-object-fields';
import { DateModule } from '@epicuro-next/ataraxia/date';
import { DiscountLabelModule } from '@epicuro-next/ataraxia/discount-label';
import { FormatPricePipe } from '@epicuro-next/ataraxia/formatting';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { ImageModule } from '@epicuro-next/ataraxia/image';
import { MarketingBadgeModule } from '@epicuro-next/ataraxia/marketing-badge';
import { MediaLightboxModule } from '@epicuro-next/ataraxia/media-lightbox';
import { PanelsModule } from '@epicuro-next/ataraxia/panels';
import { PopoverModule } from '@epicuro-next/ataraxia/popover';
import { ProductDabModule } from '@epicuro-next/ataraxia/product-dab';
import { ProductImageModule } from '@epicuro-next/ataraxia/product-image';
import { ProductPriceModule } from '@epicuro-next/ataraxia/product-price';
import { ProductTitleModule } from '@epicuro-next/ataraxia/product-title';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';
import { ConfigStripComponentModule } from '@epicuro-next/features/config-strip/component';
import { ConfigStripStateModule } from '@epicuro-next/state/config-strip-state';

import { ProductCardActionsComponent } from './components/product-card-actions/product-card-actions.component';
import { ProductCardBaseComponent } from './components/product-card-base/product-card-base.component';
import { ProductCardCommercialComponent } from './components/product-card-commercial/product-card-commercial.component';
import { ProductCardHeaderComponent } from './components/product-card-header/product-card-header.component';
import { ProductCardIconsComponent } from './components/product-card-icons/product-card-icons.component';
import { ProductCardStyleIdComponent } from './components/product-card-style-id/product-card-style-id.component';
import { ProductCardTitleComponent } from './components/product-card-title/product-card-title.component';
import { ProductCardComponent } from './components/product-card/product-card.component';

@NgModule({
  imports: [
    CommonModule,
    BadgeComponent,
    ButtonsModule,
    CardModule,
    CarouselModule,
    ClipboardModule,
    DateModule,
    DiscountLabelModule,
    FormatPricePipe,
    IconsModule,
    ImageModule,
    MarketingBadgeModule,
    MediaLightboxModule,
    PanelsModule,
    PopoverModule,
    ProductDabModule,
    ProductImageModule,
    ProductPriceModule,
    ProductTitleModule,
    TooltipDirective,
    ConcatenatedObjectFieldsComponent,
    ConfigStripComponentModule,
    ConfigStripStateModule,
    ProductCardTitleComponent,
  ],
  declarations: [
    ProductCardActionsComponent,
    ProductCardBaseComponent,
    ProductCardCommercialComponent,
    ProductCardComponent,
    ProductCardHeaderComponent,
    ProductCardIconsComponent,
    ProductCardStyleIdComponent,
  ],
  exports: [
    ProductCardActionsComponent,
    ProductCardBaseComponent,
    ProductCardCommercialComponent,
    ProductCardComponent,
    ProductCardHeaderComponent,
    ProductCardIconsComponent,
    ProductCardStyleIdComponent,
    ProductCardTitleComponent,
  ],
})
export class ProductCardModule {}
